import RingLoader from "react-spinners/RingLoader";

export default function LoadingScreen({ color = "#e7851a", loading = true }) {

    return (
        <div style={{height: '100vh', display: 'flex'}}>
        <RingLoader
            color={color}
            loading={loading}
            cssOverride={{
                margin: 'auto'
            }}
            size={60}
            aria-label="Loading..."
        />
        </div>
    );
}